import Api from "../apiService";

class DashboardsApi {
  getPeriodStats(companyId, params = {}) {
    return Api.getRequest(
      `companies/${companyId}/a1/dashboard/period_stats`,
      params,
      Api.authHeaders()
    );
  }
}

export default new DashboardsApi();
